import axiosInterceptors from "../axiosInterceptor/axiosInterceptor";
import { insuranceDetailUrl } from "../config/apiConfig";


export const getPatientLastInsuranceDetail = (patientId) => {
    return axiosInterceptors()
            .get(`${insuranceDetailUrl}/getPatientLastInsuranceDetail/${patientId}`)
            .then((res) => res);
}
